/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  getManualSearchResult.js
 */

import type { AutocompleteApiResult } from '@zcode/bizos'
import { POPULAR_SEARCHES } from '../../../../shared/components/Autocomplete/AutocompleteResults/popularSearches'

import { MIN_CHARACTER_COUNT } from '../constants'

export const getManualSearchResult = ({
  hoveredIndex,
  predictionResults,
  prevSearches,
  isShortTerm,
  searchTerm,
}: {
  hoveredIndex: number
  predictionResults: readonly AutocompleteApiResult[] | null
  prevSearches: readonly AutocompleteApiResult[] | undefined
  isShortTerm?: boolean | undefined
  searchTerm: string
}) => {
  let result

  const results = predictionResults?.length ? predictionResults : prevSearches ?? POPULAR_SEARCHES
  if (isShortTerm && results?.length) {
    result = hoveredIndex > -1 ? results[hoveredIndex] : results[0]
  } else {
    if (predictionResults?.length) {
      result = hoveredIndex > -1 ? predictionResults[hoveredIndex] : predictionResults[0]
    } else if (searchTerm?.length >= MIN_CHARACTER_COUNT && !predictionResults?.length) {
      result = hoveredIndex > -1 ? POPULAR_SEARCHES[hoveredIndex - 1] : undefined
    } else if (prevSearches?.length) {
      // Need to account for UseMyCurrentLocation component when prevSearches are being rendered
      result = hoveredIndex > -1 ? prevSearches[hoveredIndex - 1] : undefined
    } else {
      result = hoveredIndex > -1 ? POPULAR_SEARCHES[hoveredIndex - 1] : undefined
    }
  }
  return result
}
